import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors} from 'patient-ping-remedy/packages/theme';
import {Truncate} from '@/components/pages/messages/MessageThreadTitle';

export const Wrapper = styled.span<{ truncate?: Truncate; simple?: boolean }>`
  ${({ truncate }) => truncate && css`
    display: inline-flex;
    overflow: hidden;
    white-space: pre;

    ${truncate === 'unstable' && css`
      max-width: 32rem;
    `};
  `});

  ${({ simple }) => !simple && css`
    color: ${colors.primary1};
    font-weight: bold;
  `});
`;

export const Sentence = styled.span<{ truncate?: Truncate }>`
  ${({ truncate }) => truncate && css`
    text-overflow: ellipsis;
    overflow: hidden;
  `});
`;
